<template>
	<div class="page_container" :class="'p'+this.$route.name">
		<div class="page_hero p">
	  		<div>
	  			<h1>{{this.$route.meta.name}}</h1>
	  			<router-view class="fade-in fade-out"></router-view>
	  			<div class="page_about">
  					<!-- <p>{{presentation}}</p> -->
  					<div class="actions">

  						<router-link class="routerlink" to="/go/immatriculation">
				  			<div class="action cartegrise">
				  				<div class="title">
				  					<h3>Faire ma Carte Grise</h3>
				  				</div>
				  				<div class="sub">
				  					<button>C'est parti !</button>
				  				</div>
				  			</div>
			  			</router-link>

						<router-link class="routerlink" to="/conformite">
				  			<div class="action conformite">
				  				<div class="title">
					  				<h3>Commander un Certificat de Conformité</h3>
					  			</div>
					  			<div class="sub">
					  				<button>C'est parti !</button>
					  			</div>
				  			</div>
			  			</router-link>

			  			<router-link class="routerlink" to="/conduite/stages">
				  			<div class="action stages4">
				  				<div class="title">
					  				<h3>M'inscrire à un stage de récupératon de points</h3>
					  			</div>
					  			<div class="sub">
					  				<button>C'est parti !</button>
					  			</div>
				  			</div>
			  			</router-link>

<!-- 						<router-link class="routerlink" to="/immatriculation/cession">
				  			<div class="action cession">
				  				<div class="title">
					  				<h3>Déclaration de cession</h3>
					  			</div>
					  			<div class="sub">
					  				<button>En savoir plus</button>
					  			</div>
				  			</div>
			  			</router-link>

						<router-link class="routerlink" to="/immatriculation/duplicata">
			  				<div class="action duplicata">
			  					<div class="title">
				  					<h3>Demande de duplicata</h3>
				  				</div>
				  				<div class="sub">
				  					<button>En savoir plus</button>
				  				</div>
			  				</div>
		  				</router-link> -->
			  		</div>
			  		<router-link to="/go/suivi"class="btn_suivi"><button class="redGradient">Suivre l'état d'avancement de ma carte grise</button></router-link>
  				</div>
  			</div>
	  	</div>
	</div>	
</template>

<script>
	const fb = require('../firebaseConfig.js')
	import firebase from 'firebase'
	export default {
		name: 'Go',
		data () {
			return {
				presentation:''
			}
		},
		methods: {
		},
		mounted () {}
	}
</script>

<style scoped>
	.page_about{
	/*	background: rgba(204,11,66,1);*/
	/*background: #FF4D51;*/
	background-color: #22407a;
	}
	.btn_suivi{
		margin-bottom:50px;
	}
	.actions{padding-bottom:50px;}
	.page_about{display:flex;flex-direction: column;align-items: center;}
</style>


// WEBPACK FOOTER //
// src/components/Go.vue